import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  EntityType,
  OrderStatus,
  USER_ROLE_KEYS,
} from 'src/app/shared/constants/constants';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OmsServiceService {
  baseUrl = environment.BASE_URL;

  getAllApi = `${this.baseUrl}oms/order-customer`;
  getByIdApi = `${this.baseUrl}oms/order-customer/get-by-id`;
  updateApi = `${this.baseUrl}oms/order-customer/update-order`;

  omsCurrentTab: OrderStatus | null = null;

  constructor(
    private http: HttpClient,
    private commonService: CommonService,
  ) {}

  private handleError(error: HttpErrorResponse) {
    console.log(error.error.message);
    if (error.status === 0) {
      console.error('An error occurred:', error.error);
    } else {
      console.error(`Backend returned code ${error.status}, body was: `, error.error);
    }

    return throwError(() => new Error('Something bad happened; please try again later.'));
  }

  getAll(payload: any): Observable<any> {
    return this.http.post(this.getAllApi, payload).pipe(catchError(this.handleError));
  }
  getById(orderId: number): Observable<any> {
    return this.http
      .get(`${this.getByIdApi}/${orderId}`)
      .pipe(catchError(this.handleError));
  }
  update(payload: any): Observable<any> {
    return this.http.put(this.updateApi, payload).pipe(catchError(this.handleError));
  }

  requestMilestoneCommentStatus(
    entityIds: any[],
    EntityType: EntityType,
    service: string,
  ): Observable<any[]> {
    const payload = {
      entityIdList: entityIds,
      entityType: EntityType,
      receiver: USER_ROLE_KEYS.Business_Development,
    };
    return this.commonService.postDatawithoutHeaders(
      `${this.baseUrl}chat-Library/common-chat/get-read-status?service=${service}`,
      payload,
    );
  }
}
